<div class="drawer-backdrop" *ngIf="open" (click)="onBackdropClick()"></div>

<aside
  class="drawer"
  *ngIf="open"
  role="dialog"
  aria-modal="true"
  [style.--drawer-width.px]="width"
  (click)="$event.stopPropagation()"
>
  <header class="drawer-header">
    <h2 class="drawer-title">{{ title }}</h2>
    <div class="drawer-header-actions">
      <ng-content select="[drawerHeaderActions]"></ng-content>
    </div>
    <button type="button" class="icon-btn" aria-label="Fechar" (click)="close.emit()">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <section class="drawer-body">
    <ng-content select="[drawerBody]"></ng-content>
  </section>

  <footer class="drawer-footer">
    <ng-content select="[drawerFooter]"></ng-content>
  </footer>
</aside>
